import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const renderBranding = ({ hospitalName, hospitalLogo, hospitalImage, logo }) => {
    if (hospitalName || hospitalImage) {
        return (
            <div className="d-flex flex-column align-items-center mb-2 mt-5">
                {hospitalLogo && hospitalImage && (
                    <img src={hospitalImage} alt="" style={{ maxHeight: '100px', maxWidth: '100px' }} />
                )}

                {hospitalName && (
                    <span className="app-brand-text fw-bolder text-center" style={{ fontSize: '20px', color: '#041F60' }}>
                        {hospitalName}
                    </span>
                )}
            </div>
        );
    }

    return (
        <div className="d-flex flex-column align-items-center mb-2 mt-5">
            <img src="/applogo.png" alt="logo" style={{ maxHeight: '60px', maxWidth: '60px' }} />
            <span className="app-brand-text fw-bolder" style={{ fontSize: '25px', color: '#041F60' }}>
                OHOINDIA
            </span>
        </div>
    );
};

const renderFooter = (logo) => (
    <div className="d-flex flex-column align-items-center mb-2">
        {logo ? (
            <img src={logo.ConfigValue} alt="logo" style={{ height: '40px', width: '40px' }} />
        ) : (
            <div className="spinner-border text-primary" aria-hidden="true">
                <span className="visually-hidden">Loading...</span>
            </div>
        )}

        <span className="app-brand-text fw-bolder" style={{ fontSize: '18px', color: '#0094c6' }}>
            OHOINDIA
        </span>
        <span style={{ fontSize: '13px' }}>All rights reserved. Copy right <i className="bi bi-c-circle"></i> OHOINDIA</span>
        <span className="fw-semibold mt-3" style={{ color: '#0E94C3', fontSize: '13px' }}>Powerd by OHOINDIA TECHNOLOGY v1.0</span>
        <a href="https://www.ohoindialife.in/privacypolicy" target="_blank" rel="noreferrer" style={{ color: '#0E94C3' }}>
            Privacy Policy
        </a>
    </div>
);

const VerifyMemberPage = ({
    hospitalName,
    hospitalLogo,
    hospitalImage,
    mobileNumber,
    cardNumber,
    disableOtp,
    disableVerify,
    timeLeft,
    numberError,
    otpError,
    isOtpSent,
    otp,
    otpLoading,
    verifyLoading,
    isFlipped,
    remainingOtp,
    frontCard,
    backCard,
    logo,
    inputsRef,
    handleChange,
    handleKeyDown,
    handlePaste,
    handleOtpSent,
    handleVerify,
    onChangeInput,
    backFromOtp,
    toggleCardFlip,
    goToDashboard,
}) => {
    const pageBranding = renderBranding({ hospitalName, hospitalLogo, hospitalImage, logo });

    return (
        <div
            className="d-flex flex-column justify-content-start align-items-center"
            style={{ minHeight: '100vh', width: '100%', backgroundColor: '#0E94C3' }}
        >
            {isOtpSent ? (
                <div
                    className="card login-page-card d-flex flex-column justify-content-center align-items-center p-3 py-5"
                    style={{ width: '100%', maxWidth: '430px', minHeight: '100vh' }}
                >
                    <div style={{ position: 'sticky', top: '20px', display: 'flex', justifyContent: 'flex-start', width: '100%' }}>
                        <button
                            style={{
                                backgroundColor: '#0E94C3',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '30px',
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontSize: '16px',
                                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
                                cursor: 'pointer',
                                zIndex: 1000,
                            }}
                            onClick={backFromOtp}
                        >
                            <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                    </div>

                    {hospitalName || hospitalImage ? (
                        <div className="d-flex flex-column align-items-center mb-2">
                            {hospitalLogo && hospitalImage && (
                                <img src={hospitalImage} alt="" style={{ maxHeight: '100px', maxWidth: '100px' }} />
                            )}

                            {hospitalName && (
                                <span className="app-brand-text fw-bolder text-center" style={{ fontSize: '20px', color: '#041F60' }}>
                                    {hospitalName}
                                </span>
                            )}
                        </div>
                    ) : (
                        <div className="d-flex flex-column align-items-center mb-2 mt-5">
                            <img src="/applogo.png" alt="logo" style={{ maxHeight: '60px', maxWidth: '60px' }} />
                            <span className="app-brand-text fw-bolder" style={{ fontSize: '25px', color: '#041F60' }}>
                                OHOINDIA
                            </span>
                        </div>
                    )}

                    {timeLeft <= 0 ? (
                        <>
                            <h5 className="my-3 fw-bold">OTP TIMED OUT</h5>
                            <div className="d-flex flex-row justify-content-between align-items-center my-3 w-100" style={{ maxWidth: '360px' }}>
                                <div>
                                    <span>Registered Mobile number is</span>
                                    {mobileNumber && mobileNumber.length > 0 && (
                                        <h6>+91 - {mobileNumber.slice(0, 3)}XXXX{mobileNumber.slice(7, 11)}</h6>
                                    )}
                                </div>
                            </div>

                            <div className="d-flex flex-column justify-content-center mb-2 w-100" style={{ maxWidth: '360px' }}>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    onClick={handleOtpSent}
                                    style={{ backgroundColor: '#0E94C3', maxHeight: '44px' }}
                                >
                                    {otpLoading ? (
                                        <div className="spinner-border text-white fs-5" aria-hidden="true"></div>
                                    ) : (
                                        <>
                                            RESEND OTP <i className="bi bi-chevron-right fw-bolder"></i>
                                        </>
                                    )}
                                </button>
                                {numberError && numberError.length > 0 && <p className="text-danger">{numberError}</p>}
                            </div>

                            {remainingOtp && <span className="text-center mb-3">Maxium of {remainingOtp} times more left</span>}

                            <div className="d-flex flex-column align-items-center mt-auto mb-2">
                                <img src="/applogo.png" alt="logo" style={{ height: '40px', width: '40px' }} />
                                <span className="app-brand-text fw-bolder" style={{ fontSize: '18px', color: '#041F60' }}>
                                    OHOINDIA
                                </span>
                                <span style={{ fontSize: '13px' }}>All rights reserved. Copy right <i className="bi bi-c-circle"></i> OHOINDIA</span>
                                <a href="https://www.ohoindialife.in/privacypolicy" target="_blank" rel="noreferrer" style={{ color: '#0E94C3' }}>
                                    Privacy Policy
                                </a>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className="d-flex flex-row justify-content-between align-items-center my-3 w-100" style={{ maxWidth: '360px' }}>
                                <div>
                                    <span>OTP Sent to Mobile number</span>
                                    {mobileNumber && mobileNumber.length > 0 && (
                                        <h6>+91 - {mobileNumber.slice(0, 3)}XXXX{mobileNumber.slice(7, 11)}</h6>
                                    )}
                                </div>
                                <span className="border border-1 border-success rounded-pill p-2">{timeLeft}</span>
                            </div>

                            <div className="mb-3 d-flex flex-column justify-content-start w-100" style={{ maxWidth: '360px' }}>
                                <label htmlFor="otp" className="form-label">Enter One time password (OTP)</label>

                                <div className="login-otp-inputs" style={{ display: 'flex', gap: '10px' }} onPaste={handlePaste}>
                                    {otp.map((digit, index) => (
                                        <input
                                            key={`otp-box-${index + 1}`}
                                            type="text"
                                            maxLength="1"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            value={digit}
                                            onChange={(event) => handleChange(event.target.value, index)}
                                            onKeyDown={(event) => handleKeyDown(event, index)}
                                            ref={(element) => {
                                                inputsRef.current[index] = element;
                                            }}
                                            style={{
                                                width: '40px',
                                                height: '40px',
                                                textAlign: 'center',
                                                fontSize: '1.5rem',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                            }}
                                        />
                                    ))}
                                </div>
                            </div>

                            <div className="d-flex flex-column justify-content-center mb-2 w-100" style={{ maxWidth: '360px' }}>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    onClick={handleVerify}
                                    disabled={disableVerify || verifyLoading}
                                    style={{ backgroundColor: '#0E94C3', maxHeight: '44px' }}
                                >
                                    {verifyLoading ? (
                                        <div className="spinner-border text-white fs-5" aria-hidden="true"></div>
                                    ) : (
                                        <>
                                            Verify <i className="bi bi-chevron-right fw-bolder"></i>
                                        </>
                                    )}
                                </button>
                                {otpError && otpError.length > 0 && <p className="text-danger">{otpError}</p>}
                            </div>

                            <div className="d-flex flex-column align-items-center mt-auto mb-2">{renderFooter(logo)}</div>
                        </>
                    )}
                </div>
            ) : (
                <div
                    className="card login-page-card d-flex flex-column justify-content-center flex-grow-1 align-items-center p-3 pb-5"
                    style={{ width: '100%', maxWidth: '430px', minHeight: '100vh', position: 'relative' }}
                >
                    <div
                        style={{
                            position: 'sticky',
                            top: '20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                            gap: '10px',
                            flexWrap: 'wrap',
                        }}
                    >
                    </div>

                    {pageBranding}

                    <h5 className="text-secondary mb-2 text-center fw-bold" style={{ fontSize: '16px' }}>
                        OHOINDIA MEMBERSHIP VERIFICATION
                    </h5>
                    <form className="mt-3 w-100" style={{ maxWidth: '360px' }}>
                        <div className="text-start w-100">
                            <div className="d-flex flex-column w-100">
                                <label htmlFor="cardNumber" className="form-label text-black fw-medium" style={{ fontSize: '14px' }}>
                                    Enter OHO Card Number
                                </label>

                                <input
                                    type="text"
                                    className="ps-2 w-100"
                                    maxLength="14"
                                    id="cardNumber"
                                    style={{ minHeight: '40px' }}
                                    placeholder="Enter OHOCard Number"
                                    min={0}
                                    value={cardNumber}
                                    onChange={onChangeInput}
                                />

                                <p className="text-center text-secondary my-2" style={{ fontSize: '12px' }}>
                                    -------------------- <span className="mx-3">OR Enter </span> --------------------
                                </p>

                                <label htmlFor="mobileNumber" className="form-label text-black fw-medium" style={{ fontSize: '14px' }}>
                                    Registered Mobile Number
                                </label>

                                <input
                                    type="number"
                                    className="ps-2 w-100"
                                    maxLength="12"
                                    id="mobileNumber"
                                    style={{ minHeight: '40px' }}
                                    placeholder="Enter Mobile Number"
                                    min={0}
                                    value={mobileNumber}
                                    onChange={onChangeInput}
                                />

                                <div className="d-flex flex-column my-4 w-100">
                                    <button
                                        type="button"
                                        className="btn btn-primary fw-semibold"
                                        style={{ backgroundColor: '#0E94C3', maxHeight: '44px' }}
                                        disabled={disableOtp}
                                        onClick={handleOtpSent}
                                    >
                                        {otpLoading ? (
                                            <div className="spinner-border text-white fs-5" aria-hidden="true"></div>
                                        ) : (
                                            <>
                                                SUBMIT <i className="bi bi-chevron-right fw-bolder"></i>
                                            </>
                                        )}
                                    </button>

                                    {numberError && numberError.length > 0 && <p className="text-danger">{numberError}</p>}
                                </div>

                                <hr className="mt-5" />

                                <div className="d-flex flex-column align-items-center">
                                    <span style={{ fontSize: '14px' }}>OHO card number shown as below</span>
                                    <button
                                        type="button"
                                        style={{
                                            width: '100%',
                                            maxWidth: '330px',
                                            height: '200px',
                                            margin: '10px 0',
                                            perspective: '1000px',
                                            borderRadius: '5px',
                                            border: 'none',
                                            background: 'transparent',
                                            padding: 0,
                                        }}
                                        onClick={toggleCardFlip}
                                    >
                                        <div
                                            style={{
                                                position: 'relative',
                                                width: '100%',
                                                height: '100%',
                                                textAlign: 'center',
                                                transition: 'transform 0.6s',
                                                transformStyle: 'preserve-3d',
                                                transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
                                                borderRadius: '8px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    width: '100%',
                                                    height: '100%',
                                                    backfaceVisibility: 'hidden',
                                                    borderRadius: '10px',
                                                    overflow: 'hidden',
                                                }}
                                            >
                                                {frontCard ? (
                                                    <>
                                                        <img src={frontCard.ConfigValue} alt="Front side" style={{ width: '100%', height: '100%' }} />
                                                        <p
                                                            className="border border-3 border-danger"
                                                            style={{
                                                                position: 'absolute',
                                                                bottom: '8px',
                                                                left: '26px',
                                                                color: 'white',
                                                                fontSize: '1.1rem',
                                                                padding: '5px 10px',
                                                                borderRadius: '5px',
                                                            }}
                                                        >
                                                            2804 XXXX XX29
                                                        </p>
                                                    </>
                                                ) : (
                                                    <div className="spinner-border text-primary" aria-hidden="true">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </div>

                                            <div
                                                style={{
                                                    position: 'absolute',
                                                    width: '100%',
                                                    height: '100%',
                                                    backfaceVisibility: 'hidden',
                                                    transform: 'rotateY(180deg)',
                                                    borderRadius: '10px',
                                                    overflow: 'hidden',
                                                }}
                                            >
                                                {backCard ? (
                                                    <img src={backCard.ConfigValue} alt="Back side" style={{ width: '100%', height: '100%' }} />
                                                ) : (
                                                    <div className="spinner-border text-primary" aria-hidden="true">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </button>
                                </div>

                                <hr className="mt-5" />

                                {renderFooter(logo)}
                            </div>
                        </div>
                    </form>
                </div>
            )}
        </div>
    );
};

export default VerifyMemberPage;
